export default "__VITE_ASSET__CFYyLz9D__"